import React, {useEffect, useState} from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";
import ProductBox from "../ProductBox";

interface ArticleSidebarProps {
  goalName: string
}

const ArticleSidebar: React.FC<ArticleSidebarProps> = ({ goalName}) => {
  const [sidebarTop, setSidebarTop] = useState('0')

  useEffect(() => {
    const isBrowser = typeof window !== "undefined"
    const articleHeroImage = isBrowser && window.document.getElementById('ArticleImage__Hero')
    setSidebarTop(articleHeroImage ? `${articleHeroImage.offsetTop}px` : '0')
  }, []);

  return sidebarTop !== '0' ? (
    <ArticleSidebarContainer sidebarTop={sidebarTop}>
      {goalName && (
          <ProductBox goalName={goalName} />
      )}

      <Divider />

    </ArticleSidebarContainer>
  ) : <div />;
};

const ArticleSidebarContainer = styled.div`
  position: absolute;
  top: ${p => p.sidebarTop};
  right: 0;
  width: 305px;
  margin-right: calc((100vw - 1206px) / 2);

  ${mediaqueries.desktop_medium`
    margin-right: 24px;
  `};

  ${mediaqueries.desktop`
    position: relative;
    display: flex;
    top: inherit;
    z-index: 1;
    padding-bottom: 80px;
    margin: 0 24px;
    width: calc(100% - 48px);
  `};
  
  ${mediaqueries.tablet`
    position: relative;
    display: block;
    top: inherit;
    z-index: 1;
    padding-bottom: 80px;
    margin: 0 auto;
    width: 305px;
  `};

  ${mediaqueries.phablet`
    position: relative;
    top: inherit;
    z-index: 1;
    width: 100%;
    padding: 0 48px 48px;
  `};
`;

const Divider = styled.div`
  height: 16px;

  ${mediaqueries.desktop`
    width: 64px;
  `};
`;

export default ArticleSidebar;
